export default "__VITE_ASSET__CEHi4Qu7__"